import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { HttpErrorHandler, HandleError } from '../../service/http-error-handler.service';
import { HttpUtil } from '../../service/common.http';

// import OSS from 'src/assets/lib/aliyun-upload-sdk-1.5.3/aliyun-upload-sdk-1.5.3.min.js';
declare var OSS: any;
// import 'src/assets/lib/aliyun-upload-sdk-1.5.3/lib/aliyun-oss-sdk-6.17.1.min.js';
declare var AliyunUpload: any;
declare var Ks3: any;

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private httpUtil: HttpUtil,
  ) {
    this.handleError = httpErrorHandler.createHandleError('AppUploadKs3Service');
  }
  private handleError: HandleError;
  // 获取上传配置  POST
  private imgOptions = '/a/img/options';
  // 视频点播上传配置
  private uploadVodConfig = '/a/u/vod/options';
  // 转码资源查询
  private vodResourceSearch = '/a/resource/search';



  public uploader: any;

  // oss 直传 配置文件 获取参数
  private ossConfig = {
    // 金山云
    js: {
      bucket: 'thumb',
      ossType: 'js',
      conditions: JSON.stringify({
        bucket: '',
        key: '',
        acl: 'public-read',
        name: '',
        'x-kss-meta-custom-param1': '',
        'x-kss-newfilename-in-body': '',
        'Cache-Control': '',
        'Content-Disposition': '',
        Expires: ''
      })
    },
    // 阿里云
    ali: {
      bucket: 'thumb',
      ossType: 'ali',
      conditions: JSON.stringify({
        dir: 'common/'
      })
    }
  };

  // 获取上传配置
  getImgOptions(ossType): any {
    const params = this.ossConfig[ossType];
    return this.httpUtil
      .get(this.imgOptions, params)
      .pipe(catchError(this.handleError('getMerchantList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }













  // ---------------金山云上传开始-----------------

  // 金山云
  Ks3_fileUpload(params): any {
    const headers: any = {};
    const region = params.region || Ks3.config.region;
    if (region) {
      Ks3.config.baseUrl = Ks3.ENDPOINT[region];
    }
    const bucketName = params.Bucket || Ks3.config.bucket || '';
    const url = `${Ks3.config.protocol}://${Ks3.config.baseUrl}/${bucketName}/${params.merchantId}/${params.Key}`;
    const acl = params.ACL;

    if (acl === 'private' || acl === 'public-read') {
      headers['x-' + Ks3.config.prefix + '-acl'] = acl;
    }
    headers['x-kss-date'] = (new Date()).toUTCString() + '';

    const callbackurl = params.callbackurl || '';
    const callbackbody = params.callbackbody || '';
    if (callbackurl) {
      headers['x-' + Ks3.config.prefix + '-callbackurl'] = callbackurl;
    }
    if (callbackbody) {
      headers['x-' + Ks3.config.prefix + '-callbackbody'] = callbackbody;
    }
    headers.Authorization = 'KSS ' + Ks3.config.AK + ':' + params.Sinature;

    const req = new HttpRequest('PUT', url, params.File, {
      reportProgress: true,
      headers: new HttpHeaders(headers)
    });

    return this.httpUtil
      .request(req)
      .pipe(catchError(this.handleError('fileUploadKs3')));
  }

  // ---------------金山云上传结束-----------------







  // ---------------阿里云上传开始-----------------

  /**
   * 阿里云 oss直传
   * @param item file
   * @param key key
   * @param config 上传配置
   */
  aliyun_fileUpload(item, key, config): any {
    const formData = new FormData();
    formData.append('name', key);
    formData.append('key', config.dir + key);
    formData.append('policy', config.policy);
    formData.append('OSSAccessKeyId', config.accessid);
    formData.append('signature', config.signature);
    formData.append('callback', config.callback);
    formData.append('success_action_status', '200');
    formData.append('file', item.file as any);
    // 请勿修改 file 的顺序 详情： https://blog.csdn.net/Simpier/article/details/121441829

    const headers: any = {
      Accept: '*/*'
    };
    const req = new HttpRequest('POST', config.host, formData, {
      reportProgress: true,
      headers: new HttpHeaders(headers)
    });

    return this.httpUtil
      .request(req)
      .pipe(catchError(this.handleError('aliyun_fileUpload')));
  }

  /**
   * 获取视频点播上传配置
   * @param params.bucket String 同上传接口里的{module} 默认："thumb"
   * @param params.ossType String js 金山云 ali 阿里云
   * @param params.conditions String 前端实例化options参数
   * 阿里云：
   * dir 上传文件存放oss文件夹，同金山云的bucket字段，注意带"/"  {"dir":"common/"}
   */
  aliyunUploadVodConfigRequest(filePath): any {
    const filename = filePath.name.split('.');
    const key = this.getUUID() + '.' + filename[1];
    const title = key.split('.');

    const params = {
      title: title[0],
      fileName: key,
      // videoId: ''
    };
    return this.httpUtil
      .get(this.uploadVodConfig, params)
      .pipe(catchError(this.handleError('aliyunUploadVodConfigRequest', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }

  /**
   * 阿里云视频点播 转码查询
   * @param params.videoId 文件videoId
   * @param params.status 视频流转码状态。  success：成功。fail：失败。
   * @param params.fileFormat MP4等
   * @param params.eventType FileUploadComplete 文件上传完成  StreamTranscodeComplete 转码完成
   */
  vodResourceSearchRequest = (params) => {
    return this.httpUtil
      .get(this.vodResourceSearch, params)
      .pipe(catchError(this.handleError('vodResourceSearchRequest', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }

  /**
   * 阿里云oss上传视频封面
   * @param url 视频封面截图url
   */
  async aliyun_cover_Upload(url): Promise<any> {
    const { data: config } = await this.getImgOptions('ali');
    const uuid = this.getUUID();
    const coverUrl = url + '?x-oss-process=video/snapshot,t_0,w_0,h_0,m_fast,f_jpg';
    const file = await this.getImageFileFromUrl(coverUrl, uuid);
    return new Promise((resolve, reject) => {
      this.aliyun_fileUpload({ file }, uuid + '.jpg', config).subscribe((event: HttpEvent<{}> | any) => {
        if (event.type === HttpEventType.UploadProgress) {

        } else if (event instanceof HttpResponse) {
          resolve(`${config.host}/${config.dir}${uuid}.jpg`);
        }
      },
        err => {
          reject('');
        }
      );
    });
  }

  // ---------------阿里云上传结束-----------------










  /**
   * 网络资源 转换 成 File 文件，用于上传文件
   * https://blog.csdn.net/Jinzhenjie/article/details/122580726
   * @param url 网络资源链接
   * @param imageName 文件名
   * @returns File文件
   */
  getImageFileFromUrl(url, imageName): any {
    return new Promise((resolve, reject) => {
      let blob = null;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.setRequestHeader('Accept', 'image/jpeg');
      xhr.responseType = 'blob';
      xhr.onload = () => {
        blob = xhr.response;
        const imgFile = new File([blob], imageName, { type: 'image/jpeg' });
        resolve(imgFile);
      };
      xhr.onerror = (e) => {
        reject(e);
      };
      xhr.send();
    });
  }



  // 生成随机uuid
  getUUID(): any {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line:no-bitwise
      const r = Math.random() * 16 | 0;
      // tslint:disable-next-line:no-bitwise
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


}
